import React, { useContext } from 'react';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { debounce } from 'lodash';
import FilterCtx from '../../../../context/filterContext/filterCtx';

import '../../datePicker/datePicker.scss';
import '../filters.scss';
import './dateFilter.scss';

type Props = {
  dateType?: string;
  disabled?: boolean;
  placeholder?: string;
  table?: string;
};

const DateFilter: React.FC<Props> = ({ dateType, disabled, placeholder, table }) => {
  const filterCtx = useContext(FilterCtx);
  const minDate = new Date(1900, 0, 1);

  const handleDateChange = debounce((event: any) => {
    if (event.value < minDate) return;

    switch (dateType) {
      case 'FROM':
        filterCtx.setFromDate(event.value);
        return;
      case 'TO':
        filterCtx.setToDate(event.value);
        return;
      case 'AS_OF':
        filterCtx.setAsOfDate(event.value);
        return;
    }
  }, 500);

  const getDefaultValue = () => {
    switch (dateType) {
      case 'FROM':
        return new Date(filterCtx.fromDate);
        break;
      case 'TO':
        return new Date(filterCtx.toDate);
        break;
      case 'AS_OF':
        return new Date(filterCtx.asOfDate);
        break;
    }
  };

  return (
    <div className="date-pick-wrapper">
      {dateType === 'FROM' ? (
        filterCtx.fromDate ? (
          <DatePicker onChange={handleDateChange} disabled={disabled} placeholder={placeholder} defaultValue={getDefaultValue()} />
        ) : (
          <DatePicker onChange={handleDateChange} disabled={disabled} placeholder={placeholder} />
        )
      ) : null}
      {dateType === 'TO' ? (
        filterCtx.toDate ? (
          <DatePicker onChange={handleDateChange} disabled={disabled} placeholder={placeholder} defaultValue={getDefaultValue()} />
        ) : (
          <DatePicker onChange={handleDateChange} disabled={disabled} placeholder={placeholder} />
        )
      ) : null}
      {dateType === 'AS_OF' ? (
        filterCtx.asOfDate ? (
          <DatePicker onChange={handleDateChange} disabled={disabled} placeholder={placeholder} defaultValue={getDefaultValue()} />
        ) : (
          <DatePicker onChange={handleDateChange} disabled={disabled} placeholder={placeholder} />
        )
      ) : null}
    </div>
  );
};

export default DateFilter;
